let tempId = 1;

// Выдаем временный ID (в рамках приложения)
exports.getTempId = () => {
  return 'tmp' + (tempId++);
};

// Удаляем все временные ID из объекта
exports.removeTempIds = (obj) => {
  if (obj instanceof Array) {
    obj.forEach(elem => this.removeTempIds(elem));
  } else {
    if (obj instanceof Object) {
      if (obj._id && obj._id.substr(0,3) == 'tmp') {
        delete obj._id;
      } 
      for (let key of Object.keys(obj)) this.removeTempIds(obj[key]);
    }
  }

  return obj;
};